import { render, staticRenderFns } from "./CertificationVersionHistory.vue?vue&type=template&id=5014f57a&scoped=true"
import script from "./CertificationVersionHistory.vue?vue&type=script&lang=js"
export * from "./CertificationVersionHistory.vue?vue&type=script&lang=js"
import style0 from "./CertificationVersionHistory.vue?vue&type=style&index=0&id=5014f57a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5014f57a",
  null
  
)

export default component.exports